<div class="cloudSearch d-inline-block row-cols-12 p-0 sourceHeader w-100 p-2">
  <ng-content select="[search]"></ng-content>
</div>
<div class="pt-2 cloudResource">
  @if (hasSharePoint) {
    <button class="btn w-100 text-start" [disabled]="isNavigating" (click)="selectSharePoint()">
      <img src="/assets/SharePoint.png" alt="SharePoint" class="sourceIcon me-2">
      <span translate="CloudLocations.SharePoint" [ngClass]="{'text-primary': isSharePointActive()}"></span>
    </button>
  }
  @if (isSharePointActive()) {
    <ng-container *ngTemplateOutlet="folderTree; context: { $implicit: foldersForTree, level: 1 }"></ng-container>
  }

  @if (hasOneDrive) {
    <button class="btn w-100 text-start" [disabled]="isNavigating" (click)="selectOneDrive()">
      <img src="/assets/OneDrive.png" alt="OneDrive" class="sourceIcon me-2">
      <span translate="CloudLocations.OneDrive" [ngClass]="{'text-primary': isOneDriveActive()}"></span>
    </button>
  }
  @if (isOneDriveActive()) {
    <ng-container *ngTemplateOutlet="folderTree; context: { $implicit: foldersForTree, level: 1 }"></ng-container>
  }

  @if (hasTeams) {
    <button class="btn w-100 text-start" [disabled]="isNavigating" (click)="selectTeams()">
      <img src="/assets/Teams.png" alt="Teams" class="sourceIcon me-2">
      <span translate="CloudLocations.Teams" [ngClass]="{'text-primary': isTeamsActive()}"></span>
    </button>
  }
  @if (isTeamsActive()) {
    <ng-container *ngTemplateOutlet="folderTree; context: { $implicit: foldersForTree, level: 1 }"></ng-container>
  }

  @if (hasHyarchis) {
    <button class="btn w-100 text-start" [disabled]="isNavigating" (click)="selectHyarchis()">
      <img src="/assets/Hyarchis.png" alt="Hyarchis" class="sourceIcon me-2">
      <span translate="CloudLocations.Hyarchis" [ngClass]="{'text-primary': isHyarchisActive()}"></span>
    </button>
  }
  @if (isHyarchisActive()) {
    <ng-container *ngTemplateOutlet="folderTree; context: { $implicit: foldersForTree, level: 0 }"></ng-container>
  }
</div>

<ng-template #folderTree let-folders let-level="level">
  @for (folder of folders; track folder) {
    @if (folder.name) {
      <button [id]="'tree_' + folder.id"
        [ngClass]="{'text-primary': isFolderActive(folder.id)}"
        class="btn w-100 text-start folderTreeItem"
        [ngStyle]="{'padding-left.px': 16 + 13 * level}"
        [disabled]="isNavigating"
        (click)="onFolderClick(folder)">
        @if (folder.hasChildren) {
          <i class="float-start bi bi-large me-2"
          [ngClass]="{'bi-chevron-down': isFolderOpened(folder.id), 'bi-chevron-right': !isFolderOpened(folder.id)}"></i>
        }
        <span class="d-flex" [ngClass]="{'ms-4': !folder.hasChildren}">{{folder.name}}</span>
      </button>
    }
    @if (folder.children && folder.children.length > 0) {
      <ng-container *ngTemplateOutlet="folderTree; context: { $implicit: folder.children, level: level + 1 }"></ng-container>
    }
  }
</ng-template>
